import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { iif, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
const { detect } = require('detect-browser');
const browser = detect();
import { DatePipe } from '@angular/common';
import { MatRadioChange } from '@angular/material/radio';
import { filter, map, startWith } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { AddTicketTaskVm } from 'src/app/viewModels/core/core-vm';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}
@Component({
  selector: 'app-ticket-task',
  templateUrl: './ticket-task.component.html',
  styleUrls: ['./ticket-task.component.scss'],
  providers: [DatePipe],
})
export class TicketTaskComponent implements OnInit {
  subscription: Subscription;
  setBG = false
  ipAddress: string;  
  token: any;
  params: string;
  TaskListID: any;
  organizationId: any;
  userID: any;
  decryptedToken: any;
  myOfficeID: any; 
  responseHolder: any;
  myFormGroup: FormGroup; 
  tokenType: number = 0;
  folderID: number = 0; 
  databaseIdURL: any;
  device: any;
  browsername: any; 
  TaskID: any;
  taskUserEmail: any;
  accessFrom:string="";
  accessEmail:string="";
  folderId:number=0;
  subfolderId:number=0;
  spinner:boolean=false;
  coreFieldList:any=[]=[];

  coreFieldSaveCompare: any;
  coreFieldSaveCompareForType: any=[]=[];
  AllTypeList: any=[]=[];
  imagelist: any;
  coreFieldListForType:any;
  tempValue: any;
  addressFormGroup: any=[];
  dropdownlist: any=[]=[];
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;
 
  chkStatusArry: any;
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  step = 0;
  ImageUploadURL: any = '';
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  timeout = null;
  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;
  stateCtrl = new FormControl();
  scheduledTaskCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrSendlValue: any;
  stateCtrlValue: string;
  cityOption: string[]=[];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  addressValueField: any=Object;
  cityValueField: any=Object; 
  stateValueField: any=Object; 
  zipValueField: any=Object; 
  addressValue:any;
  cityValue: any;
  stateValue: any;
  zipValue: any;
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];
  getSubFolderFieldsListResponseHolder: any;
  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  arryaControlNameIdpare: any=[];
  objectList: any = [];
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  transactionUserName:string="";
  getTagListResponseHolder: any;
  tags: string[] = [];
  allTags: string[] = [];
  zipOption: any[];
  stateList: any[];
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('Input') InputFile: ElementRef;
  tagvalues: string;
  selectedColor:string = '#a59f9f';
  addByEmail:string="";
  addByName:string="";
  title:string="";
  startDate:any;
  dueDate:any;
  description:string="";
  TaskTypeID:number=0;
  TaskTicketName:string="";
  constructor(private toastr: ToastrService, private formsService: FormsService,
    private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConstant: StatusConstant,
    private http: HttpClient, private httpbackend: HttpBackend,
    private route: ActivatedRoute, private router: Router, @Inject(DOCUMENT)
    private document: Document, private coreService: CoreService,
    private formBuilder: FormBuilder, private dialog: MatDialog,
    private sanitizer: DomSanitizer, private datePipe: DatePipe,
    private addTicketTaskVm: AddTicketTaskVm, private renderer: Renderer2) {
    this.myFormGroup = new FormGroup({});
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/request/tickettask"') {
          this.setBG = true
        }
        else {
          this.setBG = false
        }
      }
    });
    var skipInterceptor = new HttpClient(httpbackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  ngOnInit(): void {
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.document.body.classList.add('whiteBg');
    this.getQueryParameter();    

    const targetUrl = this.router.url;
    if(targetUrl.includes("tickettask")){
      const appRoot = document.querySelector('app-root');
      if (appRoot) {
        this.renderer.removeClass(appRoot, 'dark-theme');  // Replace 'your-class-name' with the class you want to remove
      }
    }
    
  } 
  
  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }  
  

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.accessFrom = params['access'];
      this.accessEmail= params['email'];
      this.params = decodeURIComponent(this.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
      this.decryptedToken = JSON.parse(tokenm);
      this.folderId =  this.decryptedToken.FolderID;
      this.folderID =  this.decryptedToken.FolderID;
      this.subfolderId =  this.decryptedToken.subFolderID;
      this.tokenType = this.decryptedToken.TokenType;
      this.TaskListID = this.decryptedToken.TaskListID;
      this.organizationId = this.decryptedToken.OrganizationID;
      this.userID = this.decryptedToken.UserID;
      this.myOfficeID = this.decryptedToken.OfficeID;      
      this.TaskID=this.decryptedToken.TaskID;
      this.TaskTicketName = this.decryptedToken.title;
      this.transactionUserName = this.decryptedToken.title;
      this.TaskTypeID = this.decryptedToken.TaskTypeID;
      this.subfolderId= this.decryptedToken.subFolderID;
      const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
      this.coreFieldSaveCompareForType = [];
      this.coreFieldListForType=[];
      this.dynamicArray = [];
      this.dynamicArrayPhone = [];
      this.dynamicArrayAddress = [];
      this.dynamicArrayWebsite = [];
      this.getAllTagsList();
      let group = {};
      this.myFormGroup = new FormGroup(group);
      this.getStateDropdownList(231);        
      this.getAllFolderFields();
    });
  }


// get all created Feilds
getAllFolderFields() {   
  const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
   var reqModel = {
    userID: this.userID,
    organizationID: Number(this.organizationId),
    databaseID: 0,
    folderID: this.folderId,//17;
    subFolderID: this.subfolderId,
    fieldID: 0,
    requestFrom: 0,
    officeID: this.myOfficeID
  }
  this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConstant.statusSuccess) {
        //this.transactionUserName = this.taskDetailList.title; 
        this.coreFieldSaveCompare = response.data.activeFields.filter((m) => m.fieldID > 0);

        this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0);

        this.coreFieldList = response.data.activeFields;
        this.AllTypeList = response.data.types;
        this.AllTypeList.splice(0,0,{folderName: "Select", isChecked: false,subFolderID: 0});
       
        var NewList;
        NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
        var type;
        type = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
        NewList.splice(1, 0, type[0]);
        this.coreFieldList = NewList;

        this.imagelist = this.coreFieldList.filter((e) => e.fieldTypeName == 'Image');
        this.coreFieldList = this.coreFieldList.filter((s) => s.fieldTypeName != 'Image');
        this.coreFieldList = this.coreFieldList.filter((s) => s.isActive == true );
        this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2); 
        this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 
      
        // //=====  For Find Name ===== // 
        // let numberOfDeletedElmName = 1;
        // const elmName = this.coreFieldList.splice(0, numberOfDeletedElmName)[0];      
        // numberOfDeletedElmName = 0;      
        // this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmName, elmName);
       
        //  //=====  For Find Email ===== // 
        // const index = this.coreFieldList.findIndex(x => x.fieldName === "Email");         
        // let numberOfDeletedElmEmail = index;//+1;
        // const elm = this.coreFieldList.splice(index, 1);      
        // numberOfDeletedElmEmail = index;      
        // this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmEmail, elm[0]);

        this.coreFieldListForType = this.coreFieldList;

        const Fields = {};
        this.coreFieldList.forEach((formControl) => {
          if (formControl.fieldID == 0 && formControl.data.length > 0) {
            formControl.data.forEach((ctrlgrp,) => {
              if (ctrlgrp.fieldID > 0) {
                this.coreFieldSaveCompare.push(ctrlgrp);
                if (ctrlgrp.fieldName == 'Phone')
                  Fields[ctrlgrp.fieldName] = new FormControl(
                    '',
                    Validators.pattern(phoneNumberregex)
                  );
                else
                {
                  Fields[ctrlgrp.fieldName] = new FormControl('');
                }
                if (ctrlgrp.fieldNames.length > 0) {
                  const toSelect = ctrlgrp.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                }
              }
            });
          }
          else {
            if (formControl.fieldName == 'Phone')
              Fields[formControl.fieldName] = new FormControl(
                '',
                Validators.pattern(phoneNumberregex)
              );
            else Fields[formControl.fieldName] = new FormControl('');

            if (formControl.fieldNames.length > 0) {
              const toSelect = formControl.fieldNames[0];
              this.tempValue = toSelect;
              Fields[formControl.fieldName + 'option'] = new FormControl();
            }
          }
        });
        ///
        Fields['City'] = new FormControl();
        Fields['State'] = new FormControl();
        Fields['ZipCode'] = new FormControl();
        Fields['Country'] = new FormControl();
          // address computaion array for computation
       this.addressFormGroup.push('Address');
       this.addressFormGroup.push('City');
       this.addressFormGroup.push('State');
       this.addressFormGroup.push('ZipCode');
       this.addressFormGroup.push('Country');
       //
        ///
        this.myFormGroup = new FormGroup(Fields);

       // Check for Without Group //
        this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
        this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
        this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

        var data = [];

        data=this.coreFieldList.filter((s) => s.fieldID ==0);

        if (data.length > 0) {
          for (var i = 0, len = data.length; i < len; ++i) {
            var DrpData = [];
            DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
            if(DrpData.length>0){
              for (var v = 0, char = DrpData.length; v < char; ++v) {
                this.dropdownlist.push(DrpData[v]);
              }
            }
           
            var MultiData=[];
            MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
            if(MultiData.length>0){
              for (var v = 0, char = MultiData.length; v < char; ++v) {
                this.multipleDropdownList.push(MultiData[v]);
              }
            }
            
            var CheckboxData=[];
            CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
            if(CheckboxData.length>0){
              for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                this.checkBoxList.push(CheckboxData[v]);
              }
            }             
          }
        }               
       
        if (this.dropdownlist.length > 0) {
          var fieldListdrp = [];
          var value;
          for (let i = 0; i < this.dropdownlist.length; i++) {
            var dropValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
            value = dropValue.split(',');          
            var FieldsDrp = {
              FieldValue: this.dropdownlist[i].fieldName,
              value: value,
            };
            fieldListdrp.push(FieldsDrp);
          }
          this.dropdownlist = fieldListdrp;
        }

        if (this.multipleDropdownList.length > 0) {
          var fieldmulListdrp = [];
          var value;
          for (let i = 0; i < this.multipleDropdownList.length; i++) {
            var multidropValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
            value = multidropValue.split(',');
           
            var FieldsMulDrp = {
              FieldValue: this.multipleDropdownList[i].fieldName,
              value: value,
            };
            fieldmulListdrp.push(FieldsMulDrp);
          }
          this.multipleDropdownList = fieldmulListdrp;
        }

        if (this.checkBoxList.length > 0) {
          var fieldcheckbox = [];
          var value;
          for (let i = 0; i < this.checkBoxList.length; i++) {
            var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
            value = checkboxValue.split(',');
            var FieldsCheckbox = {
              FieldValue: this.checkBoxList[i].fieldName,
              value: value,
            };
            fieldcheckbox.push(FieldsCheckbox);
          }
          this.checkBoxList = fieldcheckbox;
        }         
      }else{
        this.loaderService.hide();
      }
    }else{
      this.loaderService.hide();
    }
  });
}

onSelectFile(fileInput: any) {
  this.handleInputChange(fileInput.target.files[0]);
  var filename = fileInput.target.files[0].name;
  var test = filename.split('.');
  this.FileName = test[0];
  this.FileExtention = '.' + test[1];
}

handleInputChange(files) {
  var file = files;
  var pattern = /image-*/;
  var reader = new FileReader();
  if (!file.type.match(pattern)) {
    alert('invalid format');
    return;
  }
  this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
  reader.readAsDataURL(file);
}

_handleReaderLoaded(e) {
  let reader = e.target;
  var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
  this.imageSrc = base64result;
  var reqModel={
    userID: this.userID,
    organizationID: Number(this.organizationId),
    databaseID: 0,
    base64String: this.imageSrc,
    fileName : this.FileName,
    fileExtention :this.FileExtention
  }
  this.coreService.getImageUlpoadURL(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.ImageUploadURL = response.data;
        }
      }
    });
}

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }  

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }
  
  // get Tag List
  getAllTagsList() {
    var obj={
      databaseID: Number(0),
      organizationID : Number(this.organizationId),
      tagName : '',
      PageSize : 0,
      officeID: this.myOfficeID,
      //OfficeIDList: this.OfficeIDList,
     }    
    this.coreService.getAllTagsList(obj).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;         
        }
        else {
  
        }
      }
    });
  }



  searchZip(zip :any){
    var obj={
      databaseID : Number(0),
      zipCodeValue: zip,
      userID : this.userID
    }   
    this.coreService.searchTransZip(obj).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {     
          this.zipOption=[];
           response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }   
 

  searchCity(name :any){ 
    var obj={
      databaseID :0,
      Name : name,
      userID: this.userID,
    }   
    this.coreService.searchTransCities(obj).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConstant.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){              
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              }             
            }
          }
        });
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addMore(fieldName: any) {
    if (fieldName == 'Email') {
      let length = this.dynamicArray.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          this.dynamicArray.push(formControl);
        }
      });
    }
    // Phone
    if (fieldName == 'Phone') {
      let length = this.dynamicArrayPhone.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          this.dynamicArrayPhone.push(formControl);
        }
      });
    }
    //Address
    if (fieldName == 'Address') {
      let length = this.dynamicArrayAddress.length;
      length = length + 1;

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));      

      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length,this.formBuilder.control(''));
      //

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          this.dynamicArrayAddress.push(formControl);
        }
      });
    }
    //Website
    if (fieldName == 'WebSite') {
      let length = this.dynamicArrayWebsite.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          this.dynamicArrayWebsite.push(formControl);
        }
      });
    }
  }

  
  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0]!=undefined ? _newdropdownlist[0].value :"";
  }

  getMuldropdownlist(fieldName) {
    var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
    return _newMuldropdownlist[0]!=undefined ? _newMuldropdownlist[0].value :"";
  }

  
  getCheckBoxlist(fieldName) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    return _newcheckBoxlist[0]!=undefined ? _newcheckBoxlist[0].value :"";
  }

  OnChange($event: any, chk: any, fieldId: any) {   
    let ckhchecked = [];
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {
      this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
      });
    } else {
      if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
        this.chkStatusArry = this.chkStatusArry.filter(
          (item) =>
            item.ckh != chk
        );
      }
    }
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check=[];
    check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if(check.length>0){
     this.fruitCtrl.setValue(null);
     return;
    }   
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags =  this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }
  

  CheckName(val){
    if(val.trim()=="" || val.trim()==undefined || val.trim()==null || val.trim()=="-" ){
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true}); 
      return;
    } 
    if (val.toLowerCase() != val.toLowerCase().match('^[a-z0-9_%+-]+@[a-z0-9-]+\\[a-z]{2,4}$')&& val.indexOf('@') == -1){     
     }else{
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true});    
     }
  }

  selectType:boolean=false;

  getSubFolderFields(event, fieldName) {
    if (event != undefined && fieldName == "Type") {  
      this.selectType=true;        
      var reqModel={
        userID : this.userID,      
        organizationID: Number(this.organizationId),
        databaseID: Number(0), 
        FolderId : this.folderID,//17;
        subFolderID: 0,
        fieldID: 0,
        requestFrom: 0,
        officeID:this.myOfficeID,        
      }        
      this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
            this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0 );
          }

          this.coreFieldListForType = response.data.activeFields.filter((s) => s.fieldTypeName != 'Image');

          var NewList;
          NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);         
        }
        this.getTypeFieldList(event);
      });
  
    }
  } 

  getTypeFieldList(event){
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.typeId = event.value;
    this.TaskTypeID = this.typeId;
    var ReqModel={
      userID : this.userID,      
      organizationID: Number(this.organizationId),
      databaseID: Number(0),    
      folderID : this.folderID,//17;
      subFolderID: this.typeId,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID
    }   
    this.coreService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderFieldsListResponseHolder = response;
        if (this.getSubFolderFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.fieldsList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter(s => s.fieldTypeName != 'Image');
                   
          this.AllTypeList = this.getSubFolderFieldsListResponseHolder.data.types;
          this.AllTypeList.splice(0,0,{folderName: "Select", isChecked: false,subFolderID: 0});
          

          this.coreFieldListForType = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldTypeName != 'Image');
        
          this.coreFieldListForType =this.fieldsList;
          this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
         // this.coreFieldList = this.coreFieldListForType;

          var NewList;
          NewList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);  
       

          this.selectedTypefieldsList = this.fieldsList.filter(({ fieldID: id1 }) => !this.coreFieldList.some(({ fieldID: id2 }) => id2 === id1));
          this.selectedTypefieldsList = this.selectedTypefieldsList.filter((s) => s.fieldID > 0);

          var tempArryacoreFieldList=[];
          tempArryacoreFieldList=this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((m) => m.fieldID == 0);

          if(tempArryacoreFieldList.length>0){
           var check= this.coreFieldList.filter(({ position: id1 }) => !this.fieldsList.some(({ position: id2 }) => id2 === id1));
           if(check.length==0){
             tempArryacoreFieldList=[];
            }
          }
          
          this.dropdownlist = this.fieldsList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.fieldsList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.fieldsList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];
          this.arryaControlNameIdpare=[];
          data=this.fieldsList.filter((s) => s.fieldID ==0);         

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
              if(DrpData.length>0){
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }
             
              var MultiData=[];
              MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
              if(MultiData.length>0){
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }
              
              var CheckboxData=[];
              CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
              if(CheckboxData.length>0){
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }             
            }
          }               

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                value = drpValue.split(',');
                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }   
           

            
             // Modified array containing group starts
             tempArryacoreFieldList.forEach(element => {
              if(element.data.length>1) {
                var indexArray=[];              
                element.data.forEach(elementin => {
                  if(elementin.fieldID>0)
                  {
                    let grpele=this.coreFieldList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
                    elementin.id=grpele!=undefined?grpele.id:0;
                    elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
                    if(elementin.fieldNames.length>0)
                    {
                      if(grpele!=undefined){
                        elementin.fieldNameID=grpele.fieldNameID;
                        elementin.placeholderVal=grpele.placeholderVal; 
                      }                                          
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName))
                    {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreFieldList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    indexArray.push(index);
                  }
                });                 
               
                this.coreFieldList = this.coreFieldList.filter(function(value, index) { 
                  return indexArray.indexOf(index) == -1; 
              }) ;
                this.coreFieldList.splice(indexArray[0],0,element);                
              }
            });
          

          if (this.selectedTypefieldsList.length == 0) {
            this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
            this.coreFieldList = this.coreFieldListForType;
            
             this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
             this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 

            //  //=====  For Find Name ===== // 
            //  let numberOfDeletedElmName = 1;
            //  const elmName = this.coreFieldList.splice(0, numberOfDeletedElmName)[0];      
            //  numberOfDeletedElmName = 0;      
            //  this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmName, elmName);
       
            //  const index = this.coreFieldList.findIndex(x => x.fieldName === "Email");         
            //  let numberOfDeletedElmEmail = index;//+1;
            //  const elm = this.coreFieldList.splice(index, 1);      
            //  numberOfDeletedElmEmail = index;      
            //  this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmEmail, elm[0]);

            const Fields = {};           
            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl(
                        '',
                        Validators.pattern(phoneNumberregex)
                      );
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl(
                    '',
                    Validators.pattern(phoneNumberregex)
                  );
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            });
         
          }
           
          this.arryaControlNameIdpare=[];

            if (this.selectedTypefieldsList.length > 0) {
            for (let i = 0; i < this.selectedTypefieldsList.length; i++) {
              this.coreFieldSaveCompare.push(this.selectedTypefieldsList[i]);            
              this.arryaControlNameIdpare.push({
                name:this.selectedTypefieldsList[i].fieldName,
                id:this.selectedTypefieldsList[i].id,
                subfolderID:this.selectedTypefieldsList[i].subfolderID
              });
              var index1 = this.fieldsList.findIndex(x=>x.fieldName==this.selectedTypefieldsList[i].fieldName && x.fieldID==this.selectedTypefieldsList[i].fieldID);
              this.coreFieldList.splice(index1,0,this.selectedTypefieldsList[i]);
            }                           

            this.selectedTypefieldsList.forEach((formControl) => {
              this.myFormGroup.addControl(formControl.fieldName, this.formBuilder.control(''));
            });

            this.coreFieldList = this.coreFieldListForType;
            
            this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2);
          //  //=====  For Find Name ===== // 
          //  let numberOfDeletedElmName = 1;
          //  const elmName = this.coreFieldList.splice(0, numberOfDeletedElmName)[0];      
          //  numberOfDeletedElmName = 0;      
          //  this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmName, elmName);
     
          //  //=====  For Find Email ===== // 
          //  const index = this.coreFieldList.findIndex(x => x.fieldName === "Email");         
          //  let numberOfDeletedElmEmail = index;//+1;
          //  const elm = this.coreFieldList.splice(index, 1);      
          //  numberOfDeletedElmEmail = index;      
          //  this.coreFieldList.splice(this.coreFieldList.length, numberOfDeletedElmEmail, elm[0]);
  
            const Fields = {};         
            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl('', Validators.pattern(phoneNumberregex));
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl('',Validators.pattern(phoneNumberregex));
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            }); 
         
          }
          else {
          }
        }
      }
    });
    
  }


  onSubmit(formValues, form) {
    // var check = this.addByEmail;
    // var newcheck:any=[];
    // newcheck=check.split(',');
    // for(var i = 0; i < newcheck.length; i++) {
    //   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   var checkemail = re.test(String(newcheck[i]).toLowerCase());
    //   if (checkemail == true) {
    //   } else {
    //     this.toastr.warning('Please provide valid email.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    // }
   
    this.myFormGroup.markAsPristine();

    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {        
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL; 
            }
          }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });
     
     
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      if(AddressDefault!=undefined){
        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["City"],
          "childFieldType": 3
        })
        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["State"],
          "childFieldType": 2
        })
        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["ZipCode"],
          "childFieldType": 4
        })
        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["Country"],
          "childFieldType": 1
        })
      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDefault; 
      }) ;
      fieldList.splice(indexDefault,0,AddressDefault);
      /************/   
      /***********/
      
      }
     

      //
      if(this.dynamicArrayAddress.length>0){
        this.dynamicArrayAddress.forEach((element,i) => {
          i=i+1;
          let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
          let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
          AddressDynamic.ChildFields.push({
            "id": 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["City"+i],
            "childFieldType": 3
          })
          AddressDynamic.ChildFields.push({
            "id": 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["State"+i],
            "childFieldType": 2
          })
          AddressDynamic.ChildFields.push({
            "id": 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["ZipCode"+i],
            "childFieldType": 4
          })
          AddressDynamic.ChildFields.push({
            "id": 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["Country"+i],
            "childFieldType": 1
          })
        fieldList = fieldList.filter(function(value, index) { 
            return index != indexDynamic; 
        }) ;
        fieldList.splice(indexDynamic,0,AddressDynamic);
  
        });
      }
    
      var checkName:any=[]=[];
      var checkEmail:any=[]=[];

      checkName = fieldList.filter(x=>x.FieldName=="Name");
      if(checkName.length>0){
        if(checkName[0].FieldValue==""){
          this.toastr.warning('Please add Name.', '', {
          timeOut: 3000,
         });
        return;
        }
      }

      checkEmail = fieldList.filter(x=>x.FieldName=="Email");
      if(checkEmail.length>0){
         const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         var checkemails = re.test(String(checkEmail[0].FieldValue).toLowerCase());
         if (checkemails == true) {
          } else {
          this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
         });
         return;
       }
      }
      if(fieldList.length>0){
        fieldList.forEach((e) => {
         if(e.FieldName=="Type"){
          e.FieldValue= (this.TaskTypeID).toString();
         }
        });
      }

      //********** */
      //this.addTicketTaskVm.ImageUrl=this.ImageUploadURL;
      var reqModel={
        title : this.title,
        description : this.description,
        status : Number(0),
        colourCode : this.selectedColor,
        isInternal : true,
        taskListID : Number(this.TaskListID),
        dueDate : this.dueDate,
        startDate : this.startDate,  
       
         customFields :{
          "folderID":this.folderId,
          "taskID": 0,
          fields: fieldList,
          "typeID": Number(this.typeId)>0?Number(this.typeId):0,
          "tags": this.tagvalues,
          "userID": this.userID,
          "organizationID": Number(this.organizationId), 
          "officeID": this.myOfficeID,   
          "databaseID": Number(0),    
         } ,
         taskTypeID : 0,
         addByEmail : this.addByEmail,
         addByName : this.addByName,
         databaseID : Number(0),        
         userID : this.userID,
         organizationID : Number(this.organizationId), 
         officeID : this.myOfficeID,
      }
      this.spinner=true;
     // this.addTicketTaskVm.Tags=this.tagvalues;
    //  this.addTicketTaskVm.TypeID=Number(this.typeId)>0?Number(this.typeId):0;     
      this.loaderService.show();
      //return;
      this.coreService.addTicketTask(reqModel).subscribe((response) => {
      if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;            
              this.tags = [];
              this.myFormGroup.reset();                
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
              this.router.navigate(['/request/thanksTicket']);  
            }else{
              this.spinner=false;
              this.loaderService.hide();
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        });
    }
  }

}

